import { useState, useEffect, useRef } from "react";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import { Link } from "react-router-dom";
import ThemeMaker from "../../../components/thememaker";
import axios from "axios";
import { tokenDecode } from "../../../utils/helper";
import { config } from "../../../utils/config";
import '../../../components/table.css';
import styles from "./issues.module.css";
import style from "../../components/Search&Options/Search&Options.module.css";
import CircularProgress from '@mui/material/CircularProgress';
import { Paginated } from "../../../components/Paginated";
import styleii from "../transaction/transaction.module.css";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import { styled } from '@mui/material/styles';
import moment from "moment";
import * as XLSX from 'xlsx';

import "../../../index.css";
import { PieChart } from '@mui/x-charts/PieChart';
import { toast } from 'react-toastify';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import brandStyles from "../../Brand/Brand.module.css";
import "../../../components/mcrbTableTheme.css";
const { apiEndpoint, baseNodeapiUrl } = config;

// /get_issue returns two different ticket shapes: IGM issues carry provider_id at
// order_details.provider_id, while grievance-style tickets have no order_details at
// all and instead list it inside refs[] as { ref_type: "PROVIDER", ref_id }.
function getIssueProviderId(item: any) {
    if (item?.order_details?.provider_id) return item.order_details.provider_id;
    const providerRef = item?.refs?.find((ref: any) => ref?.ref_type === "PROVIDER");
    return providerRef?.ref_id;
}

// /igm/get_tickets_count has returned inconsistent shapes over time: older
// responses only populated the Seller_-prefixed fields for a seller-scoped
// view, but the current API always returns the plain field names (and added
// Open_Tickets alongside the older Processing_Tickets). Read defensively so
// counts still show regardless of which shape comes back.
function pickCount(obj: any, baseKey: string) {
    if (!obj) return 0;
    if (obj[baseKey] !== undefined) return obj[baseKey];
    if (obj[`Seller_${baseKey}`] !== undefined) return obj[`Seller_${baseKey}`];
    return 0;
}
function pickOpenCount(obj: any) {
    if (!obj) return 0;
    if (obj.Open_Tickets !== undefined) return obj.Open_Tickets;
    if (obj.Seller_Open_Tickets !== undefined) return obj.Seller_Open_Tickets;
    if (obj.Processing_Tickets !== undefined) return obj.Processing_Tickets;
    if (obj.Seller_Processing_Tickets !== undefined) return obj.Seller_Processing_Tickets;
    return 0;
}

function issueStatusPillClass(rawStatus: any) {
    const s = (rawStatus || "").toString().toLowerCase();
    if (s === "closed" || s === "resolved") return styles.pillGreen;
    if (s === "escalate") return styles.pillRed;
    return styles.pillAmber;
}
// console.log("apiEndpoint", apiEndpoint);
var $ = require('jquery');

const Issues = () => {
    const decoded: any = tokenDecode();
    const [issuesList, setIssuesList] = useState([]);
    const [SearchList, setSearchList] = useState([]);
    // const [stransactionList, setStransactionList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isGraphLoading, setIsGraphLoading] = useState(false);
    const [issueDate, setissueDate]: any = useState([])
    const [Fopen, setFOpen] = useState(false);
    const handleFOpen = () => setFOpen(true);
    const handleFClose = () => setFOpen(false);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const { data } = decoded;
    console.log(data?.seller_data)
    let sellerProviderId = data?.seller_data?.provider_id
    let seller_id = data?.seller_data?.id
    const rawData = {
        seller_id: ''
    }

    // When an admin picks a seller from the "Select Seller" filter, /get_issue
    // must be called with that seller's seller_id/provider_id instead of the
    // logged-in user's own — these hold the currently-selected seller (empty
    // when no filter is active, i.e. viewing your own tickets as usual).
    const [selectedProvider, setselectedProvider]: any = useState("");
    const [selectedSellerId, setSelectedSellerId]: any = useState("");
    const [issellerSelected, setissellerselected] = useState(false);
    const { permission: { category, order, product, role, seller, tax, user } } = data;
    const [sellerList, setSellerList] = useState([]);
    const current_seller_id = decoded?.data?.user?.seller_id;
    var count = 1;
    // const shipping_address = JSON.parse(_orderDetail?.shipping_address);
    const [nextstep, setnextstep] = useState(1);
const [totalPages, setTotalPages] = useState(1);
        const [currentPage, setCurrentPage] = useState(1);
        const [showPages, setShowPages] = useState(false);
        const [searchText, setSearchText] = useState("");

        useEffect(() => {
  setnextstep(1);
}, [searchText]);

useEffect(() => {
  setnextstep(1);
}, [selectedProvider]);


useEffect(() => {
  fetchIssuesList();
}, [nextstep, searchText, selectedProvider]);

const fetchIssuesList = async () => {
  setIsLoading(true);

  try {
    const params: any = {};

    // Normal list mode
    if (!searchText) {
      params.page = nextstep;
    }

    // Search mode
    if (searchText) {
      params.issue_id = searchText;
    }

    // If an admin has picked a seller from the filter, fetch that seller's
    // tickets; "All Sellers" (nothing picked) sends the logged-in user's own
    // seller_id/provider_id, exactly as it always has — the backend already
    // treats the admin's own id as "show everything" for a root admin.
    params.seller_id = selectedProvider ? selectedSellerId : seller_id;
    params.provider_id = selectedProvider ? selectedProvider : sellerProviderId;

    const res = await axios.get(
      `${baseNodeapiUrl}/igm/get_issue`,
      {
        params, // ✅ IMPORTANT FIX
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
      }
    );

    setSearchList(res.data.data);

    // pagination handling
    if (!searchText) {
      setTotalPages(res.data.pagination.totalPages);
    } else {
      setTotalPages(1);
    }

  } catch (error: any) {
    // The API answers "no issues found" as a 404 with { status: false, data: [] }
    // instead of a 200 — axios treats that as a rejected request, so without this
    // the empty-state message never showed and the previous (stale) list stayed on screen.
    if (error?.response?.status === 404) {
      setSearchList([]);
      setTotalPages(1);
    } else {
      console.log(error);
    }
  } finally {
    setIsLoading(false);
  }
};



    const getfilterOption = async (optionvalue: any) => {
        setIsLoading(true);
        try {
            const providerID = current_seller_id === 1 ? "" : sellerProviderId;
            const { data } = await axios({
                url: `${baseNodeapiUrl}/igm/countfilter`,
                data: {
                    provider_id: providerID,
                    status: optionvalue
                },
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                }
            });
            console.log("data", data);
            setIssuesList(data?.data?.reverse());
            // const isRootSeller = current_seller_id === 1 && decoded?.data?.user?.parent_id === 0;
            // const filteredData = isRootSeller ? data?.data : data?.data?.filter((item: any) => item.order_details.provider_id === sellerProviderId);
            // setSearchList(filteredData);
            if (current_seller_id === 1 && decoded?.data?.user?.parent_id === 0) {
                setSearchList(data?.data)
            } else {
                setSearchList(data?.data?.filter((item: any) => getIssueProviderId(item) === sellerProviderId))
            }
            setIsLoading(false);
        } catch (error) {
            console.log("error", error);
            setIsLoading(false);
        }
    }






    const COLUMNS = [
        {
            Header: "Serial No.",
            accessor: (row: any, count: any) => {
                return <>{count + 1}</>
            },
            disableFilters: true,
            sticky: "left"
        },
        {
            Header: "Ticket ID",
            accessor: (item: any) => (item?.issue_id),
            sticky: "left"
        },
        {
            Header: "Issues Type",
            accessor: (item: any) => (item?.issue_type),
            sticky: "left"
        },
        {
            Header: "Category",
            accessor: (item: any) => (item?.category),
            sticky: "left"
        },
        {
            Header: "Sub Category",
            accessor: (item: any) => (item?.sub_category),
            sticky: "left"
        },
        {
            Header: "Status",
            sticky: "left",
            accessor: (item: any) => {
                const label = item?.status === "Closed" || item?.status === "CLOSED" ? "Closed"
                    : item?.status === "RESOLVED" ? "Resolved"
                    : item?.status === "ESCALATE" ? "Escalated"
                    : item?.status === "NEED-MORE-INFO" ? "Need More Info"
                    : "Processing";
                return <span className={`${styles.pillBase} ${issueStatusPillClass(item?.status)}`}>{label}</span>;
            },
        },
        {
            Header: "Action",
            filterable: true,
            sticky: "left",
            Cell: ({ row }: any) => (
                <Link to={{ pathname: '/onissues', state: { tkt: row?.original.issue_id } }} className={brandStyles.iconBtn}>
                    <VisibilityOutlinedIcon style={{ color: "#4c2fb3" }} titleAccess="View" />
                </Link>
            ),
        },
    ];

    const getSellerList = async () => {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/getsellerlist`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                }
            });
            if (data.status === 200) {
                // console.log(data.data)
                setSellerList(data.data);
            }
        } catch (error) {
            console.log("error", error);
        }
    }
    const inputHandler = async (e: any) => {
        var optionvalue = e.target.value;
        if (optionvalue === "") {
            // Clear the seller filter — go back to fetching /get_issue with the
            // logged-in user's own seller_id/provider_id.
            setselectedProvider("");
            setSelectedSellerId("");
            setissellerselected(false);
            getcounts("");
        } else {
            // Send the SELECTED seller's seller_id/provider_id to /get_issue,
            // not the admin's own — updating selectedProvider/selectedSellerId
            // triggers fetchIssuesList() via its useEffect dependency.
            const sellerObj: any = sellerList.find((s: any) => s.provider_id === optionvalue);
            setselectedProvider(optionvalue);
            setSelectedSellerId(sellerObj?.seller_id ?? "");
            getcounts(optionvalue, sellerObj?.seller_id);
            setissellerselected(true)
        }
    };

    const handlerFilterOption = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        const optionValue = e.target.value;
        optionValue === "" || optionValue === null ? fetchIssuesList() : getfilterOption(optionValue);
    };


    useEffect(() => {
        fetchIssuesList();
        getSellerList();
        getgraphData();
        if (current_seller_id == 1) {
            getcounts("");
        } else {
            getcounts(sellerProviderId);
        }


    }, []);

    const [counts, setcounts] = useState({
        Closed_Tickets: 0,
        Processing_Tickets: 0,
        Resolved_Tickets: 0,
        Total_tickets: 0,
        Seller_Closed_Tickets: 0,
        Seller_Processing_Tickets: 0,
        Seller_Resolved_Tickets: 0,
        Seller_Total_Tickets: 0
    })

    const [series, setSeries] = useState([
        {
            name: 'Open Tickets',
            data: [50, 11, 10, 40]
        },
        {
            name: 'Closed Tickets',
            data: [11, 30, 40, 76]
        }
    ]);
    const [pieChartData, setpieChartData] = useState({
        "resolved": 0,
        "open": 0,
        "closed": 0,
        // "processing": 0
    })
    const [options, setOptions] = useState<any>({
        data: [
            { label: 'Resolved', value: pieChartData.resolved },
            { label: 'Open', value: pieChartData.open },
            { label: 'Closed', value: pieChartData.closed },
            // { asset: 'Processing', amount: pieChartData.processing },

        ],
        width: 300,
        series: [
            {
                type: "pie",
                angleKey: "amount",
                calloutLabelKey: "asset",
                sectorLabelKey: "amount",
                sectorLabel: {
                    color: "white",
                    fontWeight: "bold",
                    formatter: ({ value }: any) => `${(value)}`,
                },
            },
        ],

    });

    // seller_id was previously always the logged-in user's own id here, even when
    // provider_id was overridden to a selected seller — the two would mismatch and
    // the counts/pie-chart wouldn't actually reflect the seller filter. sellerIdOverride
    // lets callers pass the SELECTED seller's numeric id alongside its provider_id.
    // "All Sellers" (providerId "") sends the logged-in user's own seller_id/
    // provider_id, exactly as it always has.
    async function getcounts(providerId: string, sellerIdOverride?: any) {
        const params: any = {
            seller_id: providerId ? (sellerIdOverride ?? "") : seller_id,
            provider_id: providerId || sellerProviderId,
        };

        try {
            const { data } = await axios({
                url: `${baseNodeapiUrl}/igm/get_tickets_count`,
                method: "GET",
                params,
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`,
                },

            });

            setcounts(data?.data);
            setpieChartData(data.data);
            setOptions((prev: any) => {
                return {
                    ...prev,
                    data: [
                        { label: 'Resolved', value: pickCount(data.data, 'Resolved_Tickets') },
                        { label: 'Open', value: pickOpenCount(data.data) },
                        { label: 'Closed', value: pickCount(data.data, 'Closed_Tickets') },
                    ]
                }
            })
        } catch (error) {
            console.log("error", error);
        }


    }

    console.log("options--------->", options)

    async function getgraphData() {
        let providerID;
        if (current_seller_id == 1) {
            providerID = ""
        } else {
            providerID = sellerProviderId
        }
        try {
            setIsGraphLoading(true)
            const { data } = await axios({
                url: `${baseNodeapiUrl}/igm/get_ticketsby_date`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`,
                },
                data: {
                    provider_id: providerID
                }
            });
            console.log(data, "IGM 213");


            if (data?.data?.length >= 0) {
                let x = data?.data?.map((item: any) => item?.date);
                let openIssueCountArray = data?.data?.map((item: any) => item?.processingCount);
                let closedIssueCountArray = data?.data?.map((item: any) => item?.resolvedCount);

                let g = [...series];
                g[0] = { ...g[0], data: openIssueCountArray };
                g[1] = { ...g[1], data: closedIssueCountArray };

                if (x && x.length > 0) {
                    setissueDate(x);
                    setOptions((prev: any) => {
                        return { ...prev, xaxis: { ...prev.xaxis, categories: x } }
                    })

                    setSeries((prev: any) => {
                        return g
                    })
                }
            }

            setIsGraphLoading(false)
        } catch (error) {
            console.log("error", error);
            setIsGraphLoading(false)
        }


    }

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        transition: "background 0.14s ease",
        '&:hover': {
            backgroundColor: "#f8fafc",
        },
    }));




    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            background: "linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%)",
            color: "#ede9fb",
            fontSize: 11,
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: "0.12em",
            borderBottom: "1px solid #5b3fc8",
            whiteSpace: "nowrap",
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 12,
            fontWeight: 500,
            color: "#1f2937",
            borderBottom: "1px solid #eef0f3",
        },
    }));

    function calculateAge(creationDateString: any, closedDateString: any) {
        var currentDate: any = new Date(); // Current date and time

        // Convert creation and closed dates to Date objects
        var creationDate: any = new Date(creationDateString);
        var closedDate: any = closedDateString ? new Date(closedDateString) : null;

        // Calculate age based on whether the item is closed or not
        var age;
        if (closedDate) {
            age = closedDate - creationDate; // Duration between creation and closure
        } else {
            age = currentDate - creationDate; // Duration between creation and current date
        }

        // Convert age from milliseconds to days (or hours, minutes, etc. as needed)
        age = age / (1000 * 60 * 60 * 24); // Convert milliseconds to days

        return age;
    }



    const palette = ['#459d55', 'rebeccapurple', 'orange', '#3498db'];



    console.log("series------>", series);

    const exportIGMTickets = () => {
        if (!SearchList || SearchList.length === 0) {
            toast.info("No tickets to export.");
            return;
        }

        const headers = ["S.No", "Ticket ID", "Order Id", "Status", "Issue Created Date", "Ageing", "Category", "Sub Category", "Closed Date"];

        const data = SearchList.map((row: any, index: number) => {
            const age = calculateAge(row?.created_at, row?.closed_time);
            return {
                "S.No": index + 1,
                "Ticket ID": row?.issue_id,
                "Order Id": row?.order_id,
                "Status": row?.status,
                "Issue Created Date": row?.created_at ? moment(row.created_at).format("DD-MM-YYYY hh:mm:ss") : "",
                "Ageing": Math.ceil(age),
                "Category": row?.category,
                "Sub Category": row?.sub_category,
                "Closed Date": row?.closed_time ? moment(row.closed_time).format("DD-MM-YYYY hh:mm:ss") : ""
            };
        });

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(data, { header: headers });
        XLSX.utils.book_append_sheet(wb, ws, 'Tickets');

        const fileName = `tickets_${new Date().getTime()}.xlsx`;
        XLSX.writeFile(wb, fileName);
        toast.success("Tickets exported successfully!");
    };

    const fileChangeHandler = async (event: any) => {
        const file = event.target.files[0];
        if (!file) {
            toast.warning("Please select a file to import.");
            return;
        }
        const allowedTypes = [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'text/csv',
            'application/octet-stream'
        ];

        if (!allowedTypes.includes(file.type) && !file.name.toLowerCase().endsWith('.xlsx') && !file.name.toLowerCase().endsWith('.xls') && !file.name.toLowerCase().endsWith('.csv')) {
            toast.error("Please select a valid Excel (.xlsx, .xls) or CSV (.csv) file.");
            event.target.value = '';
            return;
        }
        const maxSize = 10 * 1024 * 1024; // 10MB
        if (file.size > maxSize) {
            toast.error("File size must be less than 10MB.");
            event.target.value = '';
            return;
        }
        setSelectedFile(file);
    };

    const importTicketsFile = async () => {
        if (!selectedFile) {
            toast.error("No file selected. Please select a file first.");
            return;
        }
        try {
            const formData = new FormData();
            formData.append('file', selectedFile);

            const response = await axios.post(
                `${baseNodeapiUrl}/igm/import_igm`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        // Add any additional headers like authorization if needed
                        // 'Authorization': `Bearer ${yourToken}`
                    },
                }
            );

            console.log("Import successful:", response.data);
            toast.success("File imported successfully!");
            setSelectedFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        } catch (error: any) {
            console.error("Error importing tickets:", error);
            toast.error(
                error.response?.data?.message || "Failed to import file. Please try again."
            );
        }
    };

    const [showExport, setShowExport] = useState(false);

    const exportHandler = () => {
        setShowExport(true)
    }

    const [dateFilter, setDateFilter] = useState({
        startDate: "",
        endDate: ""
    })

    const dateChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setDateFilter(prev => ({
            ...prev,
            [name]: value,
        }));
    };

  const ExportHandler = async () => {
  if (!dateFilter.startDate || !dateFilter.endDate) {
    toast.error("Please select start date and end date");
    return;
  }

  try {
    const { startDate, endDate } = dateFilter;

    const response = await axios.get(
      `${baseNodeapiUrl}/igm/export_filter_igm`,
      {
        params: { startDate, endDate },
        responseType: "blob", // 🔥 REQUIRED
      }
    );

    // ✅ Create file download
    const blob = new Blob([response.data], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `Export_${startDate}_to_${endDate}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);

    setShowExport(false);
    setDateFilter({ startDate: "", endDate: "" });
    toast.success("Successfully Exported");
  } catch (error) {
    console.log("Export error", error);
    toast.error("Export failed");
  }
};



    

    return (
        <>
            <ThemeMaker>
                <div className={`${brandStyles.pageWrap} mcrb-page`}>
                    <div className={`d-flex flex-column flex-md-row justify-content-between ${styles.main}`}>
                                <div className={`${brandStyles.cardOuter} ${styles.ticketlist}`} >
                                    <div className={`${brandStyles.headerBar} mcrb-headbar`}>
                                        <span className={brandStyles.title}>Ticket List</span>

                                        <div className={styles.actionBtns}>
                                            {/* <button className={styles.ghostBtn} onClick={exportHandler}>All Export</button> */}
                                            <button className={styles.ghostBtn} onClick={handleFOpen}>Import</button>
                                            <button className={brandStyles.primaryBtn} onClick={() => { exportIGMTickets() }}>Export Tickets</button>
                                        </div>
                                    </div>

                                    {showExport && (
                                        <Modal
                                            open={showExport}
                                            onClose={()=>setShowExport(false)}
                                            aria-labelledby="modal-modal-title"
                                            aria-describedby="modal-modal-description"
                                        >
                                            <div className={styles.modalBox}>
                                                <div className={styles.modalHeader}>
                                                    <span>Export All Data</span>
                                                    <span className={styles.modalCloseBtn} onClick={()=>setShowExport(false)}>
                                                        <CloseIcon fontSize="small" />
                                                    </span>
                                                </div>

                                                <div className={styles.modalBody}>
                                                    <div className={brandStyles.field}>
                                                        <label className={brandStyles.label}>Start Date</label>
                                                        <input
                                                            type="date"
                                                            name="startDate"
                                                            className={styles.dateInput}
                                                            onChange={dateChangeHandler}
                                                        />
                                                    </div>

                                                    <div className={brandStyles.field} style={{ marginTop: "14px" }}>
                                                        <label className={brandStyles.label}>End Date</label>
                                                        <input
                                                            type="date"
                                                            name="endDate"
                                                            className={styles.dateInput}
                                                            onChange={dateChangeHandler}
                                                        />
                                                    </div>
                                                </div>

                                                <div className={styles.modalFooter}>
                                                    <button
                                                        className={brandStyles.saveBtn}
                                                        type="button"
                                                        onClick={ExportHandler}
                                                    >
                                                       Export
                                                    </button>
                                                </div>
                                            </div>
                                        </Modal>
                                    )}

                                    <div className={brandStyles.bodyArea}>

                                    <div className={`d-flex justify-content-between gap-3 my-3 ${styles.search_filter}`}>
                                        <div className="w-100">
                                            <select className={`${styles.filterSelect} ${styles.fixed_width}`} onChange={(e: any) => handlerFilterOption(e)}>
                                                <option value="" disabled selected>Search By</option>
                                                <option value="" >Search All</option>
                                                <option value="PROCESSING">Processing</option>
                                                <option value="RESOLVED">Resolved</option>
                                                <option value="CLOSED">Closed</option>
                                            </select>
                                        </div>
                                        <div className="w-100 mx-2">
                                            {current_seller_id === 1 ? (
                                                <select className={`${styles.filterSelect} ${styles.fixed_width}`} value={selectedProvider} onChange={(e: any) => inputHandler(e)}>
                                                    <option value="">All Sellers</option>
                                                    {sellerList.map((item: any, index: number) => (
                                                        <option value={item.provider_id} key={item.provider_id ?? index}>{item?.company_name}</option>
                                                    ))}
                                                </select>
                                            ) : null}
                                        </div>
                                        <div className="w-100">
                                            <input
                                                type="search"
                                                className={`${styles.searchInput} ${styles.fixed_width}`}
                                                placeholder="Enter Ticket ID"
                                                onChange={((e)=>setSearchText(e.target.value))}
                                            />
                                        </div>
                                    </div>

                                    <div className={styles.tableWrap}>
                                        {!isLoading ? <TableContainer component={Paper}   >
                                            <Table sx={{ minWidth: 500 }} aria-label="customized table" >
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCell>Serial No.</StyledTableCell>
                                                        <StyledTableCell>Ticket ID</StyledTableCell>
                                                        <StyledTableCell>Order Id</StyledTableCell>
                                                        <StyledTableCell align="center">Status</StyledTableCell>
                                                        <StyledTableCell>Issue Created Date</StyledTableCell>
                                                        <StyledTableCell>Ageing</StyledTableCell>
                                                        <StyledTableCell align="center">Category</StyledTableCell>
                                                        <StyledTableCell align="center">Sub Category</StyledTableCell>
                                                        <StyledTableCell align="center">Closed Date</StyledTableCell>
                                                        <StyledTableCell align="center">Action</StyledTableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {SearchList.length > 0 ? <>{SearchList.map((row: any, index: number) => {
                                                        const creationDate = row?.created_at;
                                                        const closedDate = row?.closed_time;
                                                        const age = calculateAge(creationDate, closedDate);
                                                        return <StyledTableRow key={row.issue_id}>
                                                            <StyledTableCell >
                                                                {(nextstep - 1) * 10 + index + 1}
                                                            </StyledTableCell>
                                                            <StyledTableCell >
                                                                {row.issue_id}
                                                            </StyledTableCell>
                                                            <StyledTableCell >
                                                                {row?.order_id}
                                                            </StyledTableCell>
                                                            <StyledTableCell align="center"><span className={`${styles.pillBase} ${issueStatusPillClass(row.status)}`}>{row.status}</span></StyledTableCell>
                                                            <StyledTableCell >
                                                                {row.created_at ? moment(row.created_at).format("DD-MM-YYYY hh:mm:ss") : ""}
                                                            </StyledTableCell>
                                                            <StyledTableCell >
                                                                {Math.ceil(age)}
                                                            </StyledTableCell>
                                                            <StyledTableCell align="center">{row.category}</StyledTableCell>
                                                            <StyledTableCell align="center">{row.sub_category}</StyledTableCell>
                                                            <StyledTableCell align="center">{row.closed_time ? moment(row.closed_time).format("DD-MM-YYYY hh:mm:ss") : ""}</StyledTableCell>
                                                            <StyledTableCell align="center"><Link to={{ pathname: '/onissues', state: { tkt: row?.issue_id } }} className={brandStyles.iconBtn}><VisibilityOutlinedIcon style={{ color: "#4c2fb3" }} titleAccess="View" /></Link></StyledTableCell>
                                                        </StyledTableRow>
                                                    })}</> : <p className={styles.emptyState}>No issue found</p>}
                                                </TableBody>
                                              
                                            </Table>
                                             
                                        </TableContainer> : <div className="d-flex  justify-content-center align-items-center" style={{ height: "100%" }}><CircularProgress /></div>}
                                       <div className={styles.paginationRow}>
                                            <ul className={styles.pageList}>
                                                    {/* First Button */}
                                                    <li>
                                                        <button
                                                            className={styles.pageBtn}
                                                            onClick={() => {
                                                                setnextstep(1);
                                                                setShowPages(true); // Show pages when navigating
                                                            }}
                                                            disabled={nextstep === 1}
                                                        >
                                                            First
                                                        </button>
                                                    </li>

                                                    {/* Previous Button */}
                                                    <li>
                                                        <button
                                                            className={styles.pageBtn}
                                                            onClick={() => {
                                                                setnextstep(prev => Math.max(prev - 1, 1));
                                                                setShowPages(true); // Show pages when navigating
                                                            }}
                                                            disabled={nextstep === 1}
                                                        >
                                                            Previous
                                                        </button>
                                                    </li>

                                                    {/* Page Numbers - Only show when showPages is true */}
                                                    {showPages && totalPages > 1 && (() => {
                                                        const pages = [];
                                                        const maxVisible = 5;
                                                        const current = nextstep;

                                                        // Always show first page
                                                        if (current > 3) {
                                                            pages.push(
                                                                <li key="first">
                                                                    <button className={styles.pageBtn} onClick={() => setnextstep(1)}>1</button>
                                                                </li>
                                                            );
                                                            if (current > 4) {
                                                                pages.push(
                                                                    <li key="ellipsis1">
                                                                        <span className={styles.pageEllipsis}>...</span>
                                                                    </li>
                                                                );
                                                            }
                                                        }

                                                        // Show current page and 2 pages around it
                                                        const startPage = Math.max(1, current - 2);
                                                        const endPage = Math.min(totalPages, current + 2);

                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pages.push(
                                                                <li key={i}>
                                                                    <button
                                                                        className={`${styles.pageBtn} ${nextstep === i ? styles.pageBtnActive : ''}`}
                                                                        onClick={() => setnextstep(i)}
                                                                    >
                                                                        {i}
                                                                    </button>
                                                                </li>
                                                            );
                                                        }

                                                        // Always show last page
                                                        if (current < totalPages - 2) {
                                                            if (current < totalPages - 3) {
                                                                pages.push(
                                                                    <li key="ellipsis2">
                                                                        <span className={styles.pageEllipsis}>...</span>
                                                                    </li>
                                                                );
                                                            }
                                                            pages.push(
                                                                <li key="last">
                                                                    <button className={`${styles.pageBtn} ${nextstep === totalPages ? styles.pageBtnActive : ''}`} onClick={() => setnextstep(totalPages)}>
                                                                        {totalPages}
                                                                    </button>
                                                                </li>
                                                            );
                                                        }

                                                        return pages;
                                                    })()}

                                                    {/* Next Button */}
                                                    <li>
                                                        <button
                                                            className={styles.pageBtn}
                                                            onClick={() => {
                                                                setnextstep(prev => Math.min(prev + 1, totalPages));
                                                                setShowPages(true); // Show pages when navigating
                                                            }}
                                                            disabled={nextstep === totalPages}
                                                        >
                                                            Next
                                                        </button>
                                                    </li>

                                                    {/* Last Button */}
                                                    <li>
                                                        <button
                                                            className={styles.pageBtn}
                                                            onClick={() => {
                                                                setnextstep(totalPages);
                                                                setShowPages(true); // Show pages when navigating
                                                            }}
                                                            disabled={nextstep === totalPages}
                                                        >
                                                            Last
                                                        </button>
                                                    </li>
                                                </ul>
                                        </div>
                                    </div>

                                    </div>
                                </div>

                                <div className={`${brandStyles.cardOuter} ${styles.countmain}`} >
                                    <div className={`${brandStyles.headerBar} mcrb-headbar`}>
                                        <span className={brandStyles.title}>Overview</span>
                                    </div>

                                    <div className={brandStyles.bodyArea}>

                                    <div className={styles.statsGrid}>

                                        <div className={styles.statTile}>
                                            <div className={styles.statIconWrap} style={{ background: "#EAF1FF" }}>
                                                <AssignmentTurnedInIcon style={{ color: "#2563EB", fontSize: 18 }} />
                                            </div>
                                            <p className={styles.statCount}>{pickCount(counts, 'Total_tickets')}</p>
                                            <p className={styles.statLabel}>Total Tickets</p>
                                        </div>

                                        <div className={styles.statTile}>
                                            <div className={styles.statIconWrap} style={{ background: "#FDEDED" }}>
                                                <PublishedWithChangesIcon style={{ color: "#DC2626", fontSize: 18 }} />
                                            </div>
                                            <p className={styles.statCount}>{pickOpenCount(counts)}</p>
                                            <p className={styles.statLabel}>Open Tickets</p>
                                        </div>

                                        <div className={styles.statTile}>
                                            <div className={styles.statIconWrap} style={{ background: "#FFF7E6" }}>
                                                <PendingActionsIcon style={{ color: "#B45309", fontSize: 18 }} />
                                            </div>
                                            <p className={styles.statCount}>{pickCount(counts, 'Processing_Tickets')}</p>
                                            <p className={styles.statLabel}>Processing Tickets</p>
                                        </div>

                                        <div className={styles.statTile}>
                                            <div className={styles.statIconWrap} style={{ background: "#E9F9EF" }}>
                                                <CheckCircleIcon style={{ color: "#16A34A", fontSize: 18 }} />
                                            </div>
                                            <p className={styles.statCount}>{pickCount(counts, 'Closed_Tickets')}</p>
                                            <p className={styles.statLabel}>Closed Tickets</p>
                                        </div>

                                        <div className={styles.statTile}>
                                            <div className={styles.statIconWrap} style={{ background: "#F5F3FE" }}>
                                                <HowToRegIcon style={{ color: "#4c2fb3", fontSize: 18 }} />
                                            </div>
                                            <p className={styles.statCount}>{pickCount(counts, 'Resolved_Tickets')}</p>
                                            <p className={styles.statLabel}>Resolved Tickets</p>
                                        </div>
                                    </div>

                                    {options?.data.some((item: any) => item.value !== 0) && <>  <PieChart
                                        colors={palette}
                                        series={[
                                            {
                                                data: options?.data,
                                                innerRadius: 40,
                                                outerRadius: 80,
                                            },
                                        ]}
                                        width={500}
                                        height={200}

                                        slotProps={{
                                            legend: { hidden: true },
                                        }}

                                    />
                                        <div className={styles.legendRow}>
                                            <div className={styles.legendItem}>
                                                <div className={styles.legendDot} style={{ background: "rgb(69, 157, 85)" }}></div>
                                                <span>Resolved</span>
                                            </div>
                                            <div className={styles.legendItem}>
                                                <div className={styles.legendDot} style={{ background: "orange" }}></div>
                                                <span>Closed</span>
                                            </div>
                                            <div className={styles.legendItem}>
                                                <div className={styles.legendDot} style={{ background: "#663399" }}></div>
                                                <span>Open</span>
                                            </div>
                                        </div>
                                    </>}

                                    </div>
                                </div>

                    </div>
                </div>
                <Modal open={Fopen}
                    onClose={handleFClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description">


                    <div className={styles.modalBox}>
                        <div className={styles.modalHeader}>
                            <span>Import Tickets</span>
                            <span className={styles.modalCloseBtn} onClick={handleFClose}><CloseIcon fontSize="small" /></span>
                        </div>

                        <div className={styles.modalBody}>
                            <div className={brandStyles.field}>
                                <label className={brandStyles.label}>Select File</label>
                                <input name="importTickets" type="file" className={brandStyles.fileInput} ref={fileInputRef} onChange={fileChangeHandler} />
                            </div>
                        </div>

                        <div className={styles.modalFooter}>
                                <button className={styles.ghostBtn} onClick={() => {
                                    handleFClose();
                                }} >Close</button>
                                <button className={brandStyles.saveBtn} type="button" onClick={importTicketsFile}>Import</button>
                            </div>
                    </div>

                </Modal >
            </ThemeMaker>
        </>
    )
}

export default Issues;